import React from 'react';
import './LivePosition.css';

const LivePosition = ({ signal }) => {
  if (!signal) {
    return (
      <div className="live-pos live-pos-loading" data-testid="live-position-loading">
        <div className="live-pos-block live-pos-block-loading">
          <div className="live-pos-pulse"></div>
          <div className="live-pos-pulse-text">Computing today's signal…</div>
        </div>
      </div>
    );
  }

  const isRotate = signal.action === 'ROTATE';
  const isRiskOff = signal.regime === 'RISK-OFF';
  const actionVerb = isRotate ? 'Rotating to' : 'Holding';
  const actionSymbol = isRotate ? signal.next_target : signal.current_holding;

  return (
    <div className="live-pos" data-testid="live-position">
      <div className={`live-pos-block ${isRotate ? 'live-pos-rotate' : ''} ${isRiskOff ? 'live-pos-riskoff' : ''}`}>
        <div className="live-pos-header">
          <span className="live-pos-label">Today's Position</span>
          <span className="live-pos-date">as of {signal.as_of_date}</span>
        </div>
        <div className="live-pos-action" data-testid="live-position-action">
          {actionVerb} {actionSymbol}
        </div>
        <div className="live-pos-regime">
          <span className={`live-pos-regime-tag ${isRiskOff ? 'off' : 'on'}`}>{signal.regime}</span>
          {isRotate && (
            <span className="live-pos-rotate-tag">from {signal.current_holding} → {signal.next_target}</span>
          )}
        </div>
      </div>
      <div className="live-pos-caption" data-testid="live-position-explainer">
        Today's Signal: <strong>{actionVerb} {actionSymbol}</strong> — {signal.explainer}
      </div>
    </div>
  );
};

export default LivePosition;
